var map = {
	"./aji.svg": 1848,
	"./algas.svg": 7585,
	"./altramuces.svg": 3584,
	"./apio.svg": 1618,
	"./e-x.svg": 2962,
	"./gluten.svg": 4190,
	"./hongo.svg": 9862,
	"./leche-coco.svg": 2790,
	"./mani.svg": 2915,
	"./mostaza.svg": 8212,
	"./nuez.svg": 6441,
	"./sesamo.svg": 1681,
	"./soja.svg": 2283
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 956;